/* HOMEWISEUK custom scripts — managed by scripts/apply-custom-assets.mjs */
(function () {
  function addBannerCovers() {
    document.querySelectorAll('.banner').forEach(function (b) {
      if (b.querySelector('.hw-banner-cover')) return;          // once only
      var links = b.querySelectorAll('.banner__buttons a[href]');
      if (links.length !== 1) return;                            // single-CTA banners only
      var a = document.createElement('a');
      a.href = links[0].getAttribute('href');
      a.className = 'hw-banner-cover';
      a.setAttribute('aria-label', (links[0].textContent || 'View').trim());
      b.appendChild(a);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBannerCovers);
  } else {
    addBannerCovers();
  }
})();
